module.exports = __webpack_public_path__ + "img/payment.e6a012c7.png";